export default __webpack_public_path__ + "static/media/social_icon_telemor.d1148dd7.jpg";